import * as actionTypes from './actionTypes'
import { userService } from '../../service'
import { authorizationHelper, errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function login(username, password) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.LOGIN_USER })

            const response = await userService.login(username, password, constants.LOGIN_GUID)
            const data = response.data
            authorizationHelper.saveAuthorizationToken(data.token)

            dispatch({
                type: actionTypes.LOGIN_USER_SUCCESS,
                payload: { user: data.user }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.LOGIN_USER_FAILURE)
        }
    }
}

export function logout() {
    return async (dispatch) => {
        authorizationHelper.removeAuthorizationToken()
        dispatch({ type: actionTypes.LOGOUT_USER })
    }
}

export function checkUserAuthentication() {
    return async (dispatch) => {
        try {
            const token = authorizationHelper.getAccessToken()
            if (token != null) {
                const response = await userService.getActualUser()
                const user = response.data

                if (!user) {
                    dispatch({ type: actionTypes.LOGOUT_USER })
                    return
                }

                dispatch({
                    type: actionTypes.LOGIN_USER_SUCCESS,
                    payload: { user }
                })
            } else {
                dispatch({ type: actionTypes.LOGOUT_USER })
            }
        } catch (error) {
            authorizationHelper.isUnauthorizedCall(dispatch, error.response)
        }

    }
}

export function requestForgotPassword(email) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_REQUEST_FORGOT_PASSWORD });
            dispatch({ type: actionTypes.REQUEST_FORGOT_PASSWORD });

            await userService.requestForgotPassword(email);

            dispatch({ type: actionTypes.REQUEST_FORGOT_PASSWORD_SUCCESS });
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.REQUEST_FORGOT_PASSWORD_FAILURE);
        }

    }
}

export function resetPassword(token, password, confirmPassword) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_REQUEST_RESET_PASSWORD });
            dispatch({ type: actionTypes.REQUEST_RESET_PASSWORD });

            await userService.resetPassword(token, password, confirmPassword);

            dispatch({ type: actionTypes.REQUEST_RESET_PASSWORD_SUCCESS });
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.REQUEST_RESET_PASSWORD_FAILURE);
        }
    }
}

export function resetCreatedUser() {
    return (dispatch) => {
        dispatch({ type: actionTypes.RESET_CREATE_USER })
    }
}

export function getUsers({ page = constants.GET_ALL_ITEMS, filter = '', storeId = constants.GET_ALL_ITEMS, reset = false, option } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_USERS })

            dispatch({ type: actionTypes.FETCH_USERS })

            const response = await userService.getAll(page, filter, storeId, option)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_USERS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_USERS_SUCCESS,
                payload: {
                    users: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_USERS_FAILURE)
        }
    }
}
export function resetUsers() {
    return (dispatch) => {
        dispatch({ type: actionTypes.RESET_USERS });
    }
}
export function getUser(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_USER_DETAIL })
            dispatch({ type: actionTypes.FETCH_USER_DETAIL })

            const response = await userService.get(id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_USER_DETAIL_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_USER_DETAIL_SUCCESS,
                payload: { user: data }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_USER_DETAIL_FAILURE)
        }
    }
}
export function resetUserDetail() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_USER_DETAIL
        });
    }
}
export function createUser(user) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.CREATE_USER })

            const response = await userService.create(user)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.CREATE_USER_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.CREATE_USER_SUCCESS,
                payload: {
                    user: data
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.CREATE_USER_FAILURE)
        }
    }
}

export function uploadUserPhoto(id, photo) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPLOAD_USER_PHOTO })
            const response = await userService.uploadPhoto(id, photo)
            const data = response.data

            dispatch({
                type: actionTypes.UPLOAD_USER_PHOTO_SUCCESS,
                payload: {
                    photoUrl: data.photoUrl
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPLOAD_USER_PHOTO_FAILURE)
        }
    }
}

export function deleteUserPhoto(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_USER_PHOTO })
            await userService.deletePhoto(id)

            dispatch({
                type: actionTypes.DELETE_USER_PHOTO_SUCCESS
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_USER_PHOTO_FAILURE)
        }
    }
}

export function updateUser(id, user) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPDATE_USER })

            const response = await userService.update(id, user)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.UPDATE_USER_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.UPDATE_USER_SUCCESS,
                payload: { user: data }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPDATE_USER_FAILURE)
        }
    }
}
export function resetUpdateUser() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_UPDATE_USER
        });
    }
}
export function deleteUser(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_USER })

            const response = await userService.deleteUser(id)
            const data = response.data

            // if (data.message) {
            //     dispatch({
            //         type: actionTypes.DELETE_USER_FAILURE,
            //         payload: { error: data.message }
            //     })

            //     return
            // }

            dispatch({
                type: actionTypes.DELETE_USER_SUCCESS,
                payload: {
                    user: { id }
                }
            })

            dispatch({ type: actionTypes.RESET_DELETE_USER })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_USER_FAILURE)
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/user/actions.js